const _data = {
	analyticsMap: {},
};

export default function addToGlobalAnalyticsMiddleware(analyticsMap) {
	_data.analyticsMap = {
		..._data.analyticsMap,
		...analyticsMap,
	};
}

export function getAnalyticsMiddleware({ getState }) {
	return (next) => (action) => {
		// for each package, pass it the state and action
		Object.keys(_data.analyticsMap).forEach((reducerName) => {
			const reducer = _data.analyticsMap[reducerName];
			const state = getState();
			reducer(state[reducerName], action);
		});
		return next(action);
	};
}



// WEBPACK FOOTER //
// ./src/shared/redux/addToGlobalAnalyticsMiddleware.js